import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import styled from "styled-components";
import toast, { Toaster } from "react-hot-toast";
import { v4 as uuidv4 } from "uuid";
import { StyledColor } from "../../interface/index";
import colors from "../../assets/colors/colors";
import { API } from "../../utils/config";

import mainStore from "../../store/index";
import Loader from "../../components/utils/Loader";
import Header from "../../components/layout/Header";
import Uploader from "../../components/utils/Uploader";

import { getDatabase, ref, set } from "firebase/database";
import {
  getAuth,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
} from "firebase/auth";

export default function Register() {
  let navigate = useNavigate();
  const STORE = mainStore();

  const [form, setForm] = useState<any>({
    name_user: "",
    last_name: "",
    phone: "",
    email: "",
    password: "",
  });
  const [form_restaurant, setFormRestaurant] = useState<any>({
    id: "",
    name: "",
    description: "",
    location: "",
    logo: "",
  });

  const [isLoader, setisLoader] = useState<boolean>(false);

  const [showFormRestaurant, setshowFormRestaurant] = useState(false);

  const [isValid, setIsValid] = useState(false);
  const [message, setMessage] = useState("");

  const [newUser, setNewUser] = useState<any>(null);

  const [validatePassword, setvalidatePassword] = useState<boolean>(false);

  useEffect(() => {
    const islogged = localStorage.getItem("token");
    if (islogged) {
      navigate("/admin-restaurant");
    }
  }, []);

  const emailRegex = /\S+@\S+\.\S+/;

  const onChange = (e: any) => {
    const value = e.target.value;
    const index = e.target.id;

    if (index === "email") {
      if (emailRegex.test(value)) {
        setIsValid(true);
        setMessage("Correo valido🙌");
      } else {
        setIsValid(false);
        setMessage("Introduce un correo valido😬");
      }
    }
    form[index] = value;
    setForm({
      ...form,
    });
  };

  const onChangeValidatePassword = (e: any) => {
    const value = e.target.value;

    if (form.password === value) {
      setvalidatePassword(true);
    } else {
      setvalidatePassword(false);
    }
  };

  const onChangeRestaurant = (e: any) => {
    const value = e.target.value;
    const index = e.target.id;

    form_restaurant[index] = value;
    setFormRestaurant({
      ...form_restaurant,
    });
  };

  const handleLogin = async () => {
    setisLoader(true);

    const auth = getAuth();
    signInWithEmailAndPassword(auth, form.email, form.password)
      .then((userCredential) => {
        // Signed in
        const user = userCredential.user as any;
        let token: any = user.accessToken;
        localStorage.setItem("token", token);
        localStorage.setItem("email", user.email || "");
        localStorage.setItem("localId", user.uid || "");
        localStorage.setItem("user_id", user.uid || "");
        setisLoader(false);
        STORE.handleUserlogged(true);
        STORE.handledLogged(true);

        navigate("/admin-restaurant");
      })
      .catch((error) => {
        console.log(error, "error user");
        const errorCode = error.code;
        const errorMessage = error.message;
      });

    return;
  };

  const handleRegister = async () => {
    setisLoader(true);
    // setisLoader(true);
    if (form.name_user === "" || form.email === "" || form.password === "") {
      toast.error("Debe de llenar todos los campos 👆");
      setisLoader(false);
      return;
    }

    const auth = getAuth();
    createUserWithEmailAndPassword(auth, form.email, form.password)
      .then((userCredential) => {
        // Signed in
        const user = userCredential.user;
        // ...
        setNewUser(user);
        createUserInUser(user);
        setisLoader(false);
      })
      .catch((error) => {
        alert("Error al crear el usuario ❌");
        const errorCode = error.code;
        const errorMessage = error.message;
      });
  };

  const createUserInUser = async (new_user: any) => {
    setisLoader(true);
    const realtime = getDatabase();

    try {
      const createUser = {
        name_user: form.name_user,
        email: new_user.email,
      };
      set(ref(realtime, "/users/" + new_user.uid), createUser);
      setshowFormRestaurant(true);
      setisLoader(false);
      toast.success("Usuario en la tabla de usuario creado con exito");
    } catch (error) {
      alert("error al crear user en la tabla de usuario");
    }
  };

  const hanldeRegisterBussines = async () => {
    setisLoader(true);
    form_restaurant["id"] = newUser.uid;

    if (form_restaurant.name === "" || form_restaurant.description === "") {
      toast.error("El nombre y la descripcion son requeridos 👆");
      setisLoader(false);
      return;
    }

    const realtime = getDatabase();

    try {
      const createRegisterBusine = { ...form_restaurant };
      set(ref(realtime, "/restaurants/" + newUser.uid), createRegisterBusine);
      setisLoader(false);
      handleLogin();
    } catch (error) {
      console.log(error, "error al crear el registro del negocio");
    }
  };

  const handleImageLogo = (image: string) => {
    form_restaurant["logo"] = image;
    setFormRestaurant({
      ...form_restaurant,
    });
  };

  return (
    <>
      <Header />
      <ContentLogin color={colors}>
        <header>
          <h1>Menu DR</h1>
          <h5>
            ¡Empezar! <br />
            Comencemos registrando tus datos
          </h5>
        </header>
        {isLoader && (
          <div className="w-100 text-center">
            <Loader color="#3498db" />
          </div>
        )}
        <div className="register">
          {!showFormRestaurant && (
            <>
              <div className="my-1">
                <label>Nombre Completo *</label>
                <input
                  type="text"
                  className="form-control shadow-none"
                  placeholder=""
                  id="name_user"
                  onChange={onChange}
                  value={form.name_user}
                />
              </div>
              <div className="my-1">
                <label>Correo electronico *</label>
                <input
                  type="email"
                  className="form-control shadow-none"
                  placeholder=""
                  id="email"
                  onChange={onChange}
                  value={form.email}
                />
                <span className={`${isValid ? "text-success" : "text-danger"}`}>
                  {message}
                </span>
              </div>
              <div className="my-1">
                <label>Contraseña *</label>
                <input
                  type="password"
                  className="form-control shadow-none"
                  placeholder="*********"
                  id="password"
                  onChange={onChange}
                  value={form.password}
                />
              </div>
              {form.password !== "" && (
                <>
                  <div className="my-1">
                    <label>Validar Contraseña *</label>
                    <input
                      type="password"
                      className="form-control shadow-none"
                      placeholder="*********"
                      id="password_2"
                      onChange={onChangeValidatePassword}
                      value={form.password_2}
                    />
                  </div>
                  {!validatePassword && (
                    <small className="text-danger">
                      Contraseña incorrecta...
                    </small>
                  )}
                </>
              )}
              <div className="my-1">
                <button
                  className="btn btn-primary d-block w-100"
                  onClick={() => handleRegister()}
                >
                  Enviar
                </button>
              </div>
            </>
          )}
          {showFormRestaurant && (
            <>
              <div>
                <label>Nombre del negocio *</label>
                <input
                  type="text"
                  className="form-control shadow-none"
                  placeholder=""
                  id="name"
                  onChange={onChangeRestaurant}
                  value={form_restaurant.name}
                />
              </div>
              <div>
                <label>Descripcion *</label>
                <input
                  type="text"
                  className="form-control shadow-none"
                  placeholder=""
                  id="description"
                  onChange={onChangeRestaurant}
                  value={form_restaurant.description}
                />
              </div>
              <div>
                <label>Ubicacion</label>
                <input
                  type="text"
                  className="form-control shadow-none"
                  placeholder=""
                  id="location"
                  onChange={onChangeRestaurant}
                  value={form_restaurant.location}
                />
              </div>
              {/* <div>
                <label>Logo</label>
                <Uploader newImage={handleImageLogo} />
              </div> */}
              <div>
                <button
                  className="btn btn-primary d-block w-100"
                  onClick={() => hanldeRegisterBussines()}
                >
                  Enviar
                </button>
              </div>
            </>
          )}
          <div className="text-center">
            <Link to="/login">Ya tengo una cuenta</Link>
          </div>
        </div>
        <Toaster position="bottom-center" reverseOrder={false} />
      </ContentLogin>
    </>
  );
}

const ContentLogin = styled.div<StyledColor>`
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  // background: #3498db36;
  header {
    text-align: center;
    padding: 1em;
    h1 {
      font-weight: bold;
      color: ${(props) => props.color.black};
    }
  }
  .register {
    margin: 3em 0;
    width: 90% !important;
    padding: 1em;
    /* background: white; */
    border-radius: 12px;
    margin: 0 !important;

    div {
      padding: 0.5em 0;
    }
  }
`;
